<template>
    <div
        :class="['stage-shortcut-leader', {'stage-shortcut-leader--visible': visible}]"
    >
        <div class="stage-shortcut-leader-panel">
            <svg-vue class="stage-shortcut-leader-icon" icon="font-awesome.regular.command"></svg-vue>
            <span
                v-if="showLabel"
                class="stage-shortcut-leader-label"
            >
                {{ label }}
            </span>
        </div>
    </div>
</template>

<script>
import {subscribeNavigationShortcutLeaderState} from "@/utils/navigation-shortcuts";

export default {
    name: "navigation-shortcut-leader-indicator",
    data() {
        return {
            visible: false,
            label: '',
            unsubscribe: null,
        };
    },
    computed: {
        showLabel() {
            return !!this.label && this.label !== '⌘';
        },
    },
    mounted() {
        this.unsubscribe = subscribeNavigationShortcutLeaderState((state) => {
            this.visible = !!(state && state.active);
            this.label = state && state.label ? state.label : '';
        });
    },
    beforeUnmount() {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    },
};
</script>
